import React, { useState, useEffect } from 'react'
import Title from 'shared/components/Title'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import jwt_decode from 'jwt-decode'
import * as R from 'ramda'
import {
  isSequenceNumber,
  isRepeated,
  isValidPasswordLength,
  isValidPasswordPattern,
  getInValidMessage,
} from '../../libs/text-validation'
import constants from 'config/constants'
import { signupUser } from 'actions'
import { toast } from 'libs/toast'
import InviteeRegistrationPresentation from './presentation'
import { Loader } from 'shared/components/Loader'

const API_URL = constants.backendHost

const InviteeRegistration = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { token } = useParams()

  const [loading, setLoading] = useState(true)
  const [inviter, setInviter] = useState({})
  const [form, setForm] = useState({ name: null, password: null })

  const [availableLoginMethods, setAvailableLoginMethods] = useState([])

  function onTextChange(event) {
    const { name, value } = event.target
    setForm({ ...form, [name]: value })
  }

  function onSubmit(event) {
    event.preventDefault()

    var password = String(form.password)
    var name = String(form.name)
    var errorMessage = ''

    const isInValidPassword =
      !isValidPasswordLength(password) ||
      !isValidPasswordPattern(password) ||
      isSequenceNumber(password) ||
      isRepeated(password)

    if (isInValidPassword) {
      errorMessage = getInValidMessage(password)
      toast.error('Oops! ' + errorMessage)
    } else {
      const [firstname] = name.split(/\s+/)
      const data = {
        invite_token: token,
        password: password,
        firstname,
        lastname: name.split(/\s+/).slice(1).join(' '),
      }
      dispatch(signupUser(data))
        .then((isAuthenticated) => {
          if (isAuthenticated) {
            history.replace({ pathname: '/' })
          } else {
            toast.error('Oops! Token went wrong, please contact Simplesat support for help.')
          }
        })
        .catch((error) => {
          toast.error('Oops! Something went wrong, please contact Simplesat support for help.')
          throw error
        })
    }
  }

  useEffect(() => {
    const validateToken = async (token) => {
      const response = await fetch(`${API_URL}/api/account/invitation/${token}/?verify=true`, {
        method: 'GET',
        headers: {
          Authorization: '',
          'X-Workspace-Token': '',
        },
      })

      if (!response.ok) {
        throw new Error('Token validation failed')
      }

      return await response.json()
    }

    if (token && loading) {
      validateToken(token)
        .then((data) => {
          setInviter(jwt_decode(token, { header: false }))
          setAvailableLoginMethods(data.login_methods || [])
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
          history.push('/invalid-invite-token')
        })
    }
  }, [history, loading, token])

  if (loading) {
    return <Loader />
  }

  return (
    <React.Fragment>
      <Title title="Create your new account" />
      <InviteeRegistrationPresentation
        name={form.name}
        password={form.password}
        company={R.prop('inviter_company', inviter)}
        inviterName={R.prop('inviter_name', inviter)}
        availableLoginMethods={availableLoginMethods}
        onTextChange={onTextChange}
        onSubmit={onSubmit}
      />
    </React.Fragment>
  )
}
export default InviteeRegistration



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/InviteeRegistration/index.js